import "./Modal.scss";
import { useEffect, useRef } from "react";

function Modal({ isOpen, onClose, title, children, size, noHeader, chatHeader }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!isOpen) return;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.classList.add("modal-open");
    const dialog = dialogRef.current;
    const focusable = () => Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex="0"]')).filter((el) => el.getClientRects().length);
    (focusable()[0] || dialog).focus({ preventScroll: true });
    const onKeyDown = (event) => {
      if (event.key === "Escape") { event.preventDefault(); closeRef.current(); }
      if (event.key !== "Tab") return;
      const items = focusable();
      if (!items.length) { event.preventDefault(); dialog.focus(); return; }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {
        event.preventDefault(); first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.documentElement.classList.remove("modal-open");
      document.removeEventListener("keydown", onKeyDown);
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [isOpen]);

  return (
    <div
      className={`privacy-modal-backdrop ${isOpen ? "active" : ""} ${noHeader ? "no-header" : ""}`}
      aria-hidden={!isOpen}
      inert={!isOpen ? "" : undefined}
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-label={title || (chatHeader ? `Contact ${chatHeader.name}` : "Details")}
        tabIndex={-1}
        className={`privacy-modal-content ${isOpen ? "active" : ""} ${
          size === "large" ? "large" : ""
        } ${chatHeader ? "chat-header" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {!noHeader && (
          <>
            {chatHeader ? (
              <div className="chat-header-container">
                <div className="chat-header-info">
                  <img
                    src={chatHeader.avatar}
                    alt={chatHeader.name}
                    className="chat-avatar"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="chat-header-text">
                    <h3 className="chat-header-name">{chatHeader.name}</h3>
                    {chatHeader.status && (
                      <p className="chat-header-status">{chatHeader.status}</p>
                    )}
                  </div>
                </div>
                <button onClick={onClose} className="privacy-modal-close" aria-label="Fermer">
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg>
                </button>
              </div>
            ) : (
              <div className="title-close">
                <h2 className="title-font">{title}</h2>
                <button onClick={onClose} className="privacy-modal-close" aria-label="Fermer">
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg>
                </button>
              </div>
            )}
          </>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
